module.exports = __webpack_public_path__ + "static/media/red.a931204a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/red.png
// module id = 59
// module chunks = 0